import { atom } from "jotai";

/**
 * Bounding rect of the element that opened the player, so it can place
 * itself beside the trigger instead of centering.
 */
export interface VideoPreviewAnchorRect {
  top: number;
  left: number;
  right: number;
  bottom: number;
}

/**
 * The sub-rosa video currently open in the floating player, or null when
 * nothing is playing.
 */
export interface VideoPreviewTarget {
  file: { id: string; key: string; fileName: string };
  /** HH:MM:SS to seek to on open, or null to start from the beginning. */
  startTime: string | null;
  /** Omitted by callers with no meaningful anchor (e.g. the sidebar). */
  anchorRect?: VideoPreviewAnchorRect;
}

/**
 * Global target for the floating sub-rosa video player.
 *
 * Deliberately plain state rather than a fire-once command atom: the Case
 * Documents sidebar is mounted above the tab tree and can dispatch from any
 * tab, while the previous consumer (RecordReviewTab) only mounts once its
 * own tab has been visited — so commands sent from elsewhere were silently
 * dropped, then replayed stale when that tab finally mounted. The player is
 * now mounted app-wide by `GlobalVideoPreview`, which owns this atom.
 */
export const videoPreviewTargetAtom = atom<VideoPreviewTarget | null>(null);
